
$(document).ready(function (e) {

	(function ($) {
		'use strict';
		// call our plugin
		var Nav = new hcOffcanvasNav('#main-nav #menu-main-menu', {
			disableAt: false,
			customToggle: '.toggle',
			levelSpacing: 50,
			//navTitle: 'All Categories',
			levelTitles: true,
			levelTitleAsBack: true,
			pushContent: '#container-box',
			labelClose: false
		});

	})(jQuery);

	////////////
	if ($('#main-banner').length) {
		$('#main-banner').owlCarousel({
			autoplay: true,
			dots: false,
			nav: false,
			navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
			rewind: true,
			autoplayTimeout: 7000,
			loop: true,
			items: 1,
			margin: 0,
			responsive: {
				200: { items: 1 },
				300: { items: 1 },
				630: { items: 1 },
				980: { items: 1 }
			}
		});
	}

	if ($('#new-arrival').length) {
		$('#new-arrival').owlCarousel({
			autoplay: true,
			dots: false,
			nav: true,
			navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
			rewind: true,
			autoplayTimeout: 5000,
			loop: true,
			items: 3,
			margin: 15,
			responsive: {
				200: { items: 1 },
				640: { items: 2 },
				991: { items: 2 },
				1160: { items: 3 }
			}
		});
	}

	if ($('#scrol-bar').length) {
		$('#scrol-bar').owlCarousel({
			autoplay: true,
			dots: false,
			nav: false,
			navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
			rewind: true,
			autoplayTimeout: 3000,
			loop: true,
			items: 2,
			margin: 15,
			responsive: {
				200: { items: 1 },
				640: { items: 2 },
				991: { items: 2 }
			}
		});
	}
	if ($('#custm-revw').length) {
		$('#custm-revw').owlCarousel({
			autoplay: true,
			dots: false,
			nav: true,
			navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
			rewind: true,
			autoplayTimeout: 5000,
			loop: true,
			items: 2,
			margin: 30,
			responsive: {
				200: { items: 1 },
				300: { items: 1 },
				630: { items: 2 },
				980: { items: 2 }
			}
		});
	}
  
  
    
   
  

});


